import React from 'react';
import { AvatarGroupSelect } from 'shared/components/Avatars/AvatarGroupSelect';
import { useAvatarGroupSelectOptions } from 'shared/components/Avatars/AvatarGroupSelect/useAvatarGroupSelectOptions';
import { IOption, PopoverPlacement } from 'shared/components/Dropdown';

type AssigneeSelectorProps = {
  selectedUserIds?: string[];
  onToggle?: (option: IOption) => void;
};

const AssigneeSelector = ({ selectedUserIds, onToggle }: AssigneeSelectorProps): JSX.Element => {
  const options = useAvatarGroupSelectOptions({ selectedUserIds });
  return <AvatarGroupSelect
    options={options}
    avatarSize="xs"
    popoverPlacement={PopoverPlacement.BottomEnd}
    onToggle={(_e, option): void => onToggle?.(option)}
    showRemoveButton={!!onToggle}
    isAddingAvatar={!!onToggle}
  />
};

export default AssigneeSelector;
